/**
 * Formats a currency string.
 *
 * @param input - The input string (e.g., "USD1000").
 * @returns The formatted currency string (e.g., "$ 1,000").
 *
 * @example
 * formatCurrency("USD1000"); // "$ 1,000"
 * formatCurrency("JPY4000"); // "JPY 4,000"
 */
export const formatPrice = (input: string) => {
  // Match strings like "USD1000" or "EUR1000"
  const match = input.match(/^([a-zA-Z]+)(\d+)$/);

  if (!match) return input;

  const [, currencyCode, amount] = match;

  // Format the amount with commas for thousands
  const formattedAmount = parseInt(amount, 10).toLocaleString();

  const currencySymbols: { [key: string]: string } = {
    USD: '$',
    EUR: '€',
    GBP: '£',
  };

  const currencySymbol =
    currencySymbols[currencyCode.toUpperCase()] || currencyCode.toUpperCase();
  return `${currencySymbol} ${formattedAmount}`;
};
